/** Approvals sahifasi lug'ati (en: manba). */
export default {
  title: "Approvals",
  subtitle: "{{scope}} · {{count}} waiting for your decision",
  scope: { all: "All branches", myBranch: "My branch" },
  history: "History",
  backToPending: "Back to pending",
  kind: { hire: "Hire", transfer: "Transfer", expense: "Expense", bonus: "Bonus" },
  kinds: { hire: "Hires", transfer: "Transfers", expense: "Expenses", bonus: "Bonuses" },
  hireInfo: "A hire is counted in reports, KPI and bonuses only after approval.",
  loadFailed: "Could not load approvals.",
  empty: {
    history: "No decisions yet",
    historyDesc: "Decided requests will appear here.",
    pending: "No pending {{kind}}",
    pendingDesc: "New requests arrive here in real time.",
  },
  pagination: "requests",
  recent: { title: "Recently decided", none: "Nothing decided yet", by: "by {{who}}" },
  toast: {
    approved: "Approved: {{name}}",
    rejected: "Rejected: {{name}}",
    alreadyDecided: "Already decided or changed",
    listRefreshed: "The list was refreshed.",
    saveFailed: "Could not save the decision",
    checkConnection: "Check your connection and try again.",
  },
  columns: {
    driver: "Driver",
    recruiter: "Recruiter",
    carrierJob: "Carrier / Job",
    startDate: "Start date",
    evidence: "Evidence",
    submitted: "Submitted",
    decision: "Decision",
    actions: "Actions",
    fromTo: "From owner → To",
    requestedBy: "Requested by",
    note: "Note",
    branch: "Branch",
  },
  noConfirmation: "No carrier confirmation",
  pool: "pool",
  markedBy: "marked by {{who}}",
  approve: {
    title: "Approve {{what}}",
    hireHint: "After approval the hire counts in reports, KPI and the recruiter's bonus. Retention checks (30/60/90 days) are scheduled automatically.",
    note: "Note (optional)",
    notePlaceholder: "Confirmed by carrier email…",
    fee: "Carrier fee from {{carrier}} ($)",
    feeHint: "What the carrier pays for this driver. Change it later in Budget → Carrier payments; the money is recorded there when it arrives.",
  },
  reject: {
    title: "Reject {{what}}",
    reason: "Reason",
    chooseReason: "Choose a reason…",
    reasonPlaceholder: "Why is this rejected?",
    returnTo: "Return driver to status",
    comment: "Comment for recruiter",
    commentPlaceholder: "Ask the carrier to confirm the start date by email",
    footnote: "The recruiter gets a notification. Nothing is deleted; the decision is logged.",
    rejectHire: "Reject hire",
    reasonRequired: "Reason is required.",
  },
};
